<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Kicking Goals</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgements">Acknowledgements</a></li>
<li id="toc-li-5"><a href="#/text/ch005#foreword">Foreword</a></li>
<li id="toc-li-6"><a href="#/text/ch006#authors-note">Author’s Note</a></li>
<li id="toc-li-7"><a href="#/text/ch007#chapter-1">Chapter 1: I Hate School</a><ol class="toc"><li id="toc-li-8"><a href="#/text/ch007#i-hate-school"></a></li>
</ol></li>
<li id="toc-li-9"><span href="#/text/ch008#chapter-2" title="Link target outside of Sample">Chapter 2: Boots</span><ol class="toc"><li id="toc-li-10"><span href="#/text/ch008#boots" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-11"><span href="#/text/ch009#chapter-3" title="Link target outside of Sample">Chapter 3: Bad Boy Bart</span><ol class="toc"><li id="toc-li-12"><span href="#/text/ch009#bad-boy-bart" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-13"><span href="#/text/ch010#chapter-4" title="Link target outside of Sample">Chapter 4: Self-Defence</span><ol class="toc"><li id="toc-li-14"><span href="#/text/ch010#self-defence" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-15"><span href="#/text/ch011#chapter-5" title="Link target outside of Sample">Chapter 5: Haymaking</span><ol class="toc"><li id="toc-li-16"><span href="#/text/ch011#haymaking" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-17"><span href="#/text/ch012#chapter-6" title="Link target outside of Sample">Chapter 6: Chickenpox</span><ol class="toc"><li id="toc-li-18"><span href="#/text/ch012#chickenpox" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-19"><span href="#/text/ch013#chapter-7" title="Link target outside of Sample">Chapter 7: Ladies, a Plate</span><ol class="toc"><li id="toc-li-20"><span href="#/text/ch013#ladies-a-plate" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-21"><span href="#/text/ch014#chapter-8" title="Link target outside of Sample">Chapter 8: Hens in a Dustbin</span><ol class="toc"><li id="toc-li-22"><span href="#/text/ch014#hens-in-a-dustbin" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-23"><span href="#/text/ch015#chapter-9" title="Link target outside of Sample">Chapter 9: Sawdust for Brains</span><ol class="toc"><li id="toc-li-24"><span href="#/text/ch015#sawdust-for-brains" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-25"><span href="#/text/ch016#chapter-10" title="Link target outside of Sample">Chapter 10: The Surprise</span><ol class="toc"><li id="toc-li-26"><span href="#/text/ch016#the-surprise" title="Link target outside of Sample"></span></li>
</ol></li>
<li id="toc-li-27"><span href="#/text/ch017#epilogue" title="Link target outside of Sample">Epilogue</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?5e6d988e